<template>
  <div class="body">
    <div class="title">
      社团管理
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"
            ><span class="dsadf"> 首页 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>社团管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="csass">
        <vxe-button
          size="medium"
          content="添加社团"
          status="primary"
          @click="routeAdd"
        ></vxe-button>
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-input
              v-model="query.keyword"
              placeholder="名称"
              @blur="Discountsearch"
            />
          </el-form-item>
          <el-form-item>
            <el-select
              placeholder="上下架"
              v-model="query.is_status"
              @change="Discountsearch"
              style="min-width: 168px; width: 168px"
              clearable
            >
              <el-option name="selected" :value="0" label="全部 "></el-option>
              <el-option name="selected" :value="1" label="下架 "></el-option>
              <el-option name="selected" :value="2" label="上架 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="申请日期"
              v-model="query.apply_date"
              @change="Discountsearch"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 300px"
              v-model="query.org_areaid"
              @change="Discountsearch"
              placeholder="选择社团区域"
            >
              <el-option
                v-for="item in areaList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-select  placeholder="类型" v-model="query.org_type" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option
                v-for="item in optiontype"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <!--        <el-form-item>-->
          <!--          <el-cascader-->
          <!--            :options="CityInfo"-->
          <!--            v-model="query.org_provinceid"-->
          <!--            :change-on-select="true"-->
          <!--            :clearable="true"-->
          <!--            :filterable="true"-->
          <!--            @change="Discountsearch">-->
          <!--           </el-cascader>-->
          <!--        </el-form-item>-->
        </el-form>
      </div>
    </div>
    <vxe-table
      border
      show-overflow
      keep-source
      ref="xTable"
      max-height="750"
      class="mytable-scrollbar"
      :data="tableData"
      align="center"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        icon: 'fa fa-pencil',
        showStatus: true,
      }"
    >
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="id" title="编号" width="80"></vxe-table-column>
      <vxe-table-column
        field="org_com"
        title="协会名称"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column title="协会logo" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.org_logo" style="width: 70px; height: 70px" />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column title="协会类型"  width="100">
        <template  slot-scope="scope">
          {{scope.row.org_type === 1 ?'商会':'协会'}}
        </template>
      </vxe-table-column> -->
      <vxe-table-column title="所在区域" width="150">
        <template slot-scope="scope">
          {{ scope.row.org_area_l3 }} {{ scope.row.org_town_name || "" }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="org_mobile"
        title="协会联系人电话"
        width="120"
      ></vxe-table-column>
      <!-- <vxe-table-column title="协会状态"  width="100">
        <template  slot-scope="scope">
          <span v-if="scope.row.verify_status === 0" class="daitongguo">待通过</span>
          <span v-if="scope.row.verify_status === 2" class="weitongguo">未通过</span>
          <span v-if="scope.row.verify_status === 1" class="yizhiding">已通过</span>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column
        field="status_time"
        title="审核时间"
        width="120"
      ></vxe-table-column> -->
      <vxe-table-column title="上架状态" width="100">
        <template slot-scope="scope">
          <el-switch
            @change="sexChangeListOption(scope.row)"
            v-model="scope.row.shangjia"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <span
            :style="{
              color: scope.row.is_status === 0 ? '#F7D05C' : '#17ab3f',
            }"
          >
            {{ scope.row.is_status === 1 ? "上架" : "下架" }}
          </span>
        </template>
      </vxe-table-column>
      <vxe-table-column title="党建组织" width="100">
        <!-- <template slot-scope="scope">
          <el-switch
            @change="sexChangeListOption(scope.row)"
            v-model="scope.row.shangjia"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <span
            :style="{
              color: scope.row.is_status === 0 ? '#F7D05C' : '#17ab3f',
            }"
          >
            {{ scope.row.is_status === 1 ? "是" : "否" }}
          </span>
        </template> -->
      </vxe-table-column>
      <!-- <vxe-table-column field="zhiding" title="置顶状态"  width="100">
        <template  slot-scope="scope">
          <span v-if="scope.row.is_top === 0" class="weizhiding">未置顶</span>
          <span v-if="scope.row.is_top === 1" class="yizhiding">置顶(剩余{{scope.row.istop_surplusdays}}天)</span>
        </template>
      </vxe-table-column> -->
      <vxe-table-column title="操作" min-width="280" fixed="right">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <div class="rou">
            <el-button size="mini" @click="xiehuixiangqing(scope.row)">
              查看详情
            </el-button>
            <el-button
              @click="Editscs(scope.row)"
              v-if="scope.row.is_add"
              size="mini"
            >
              编辑
            </el-button>

            <el-dropdown>
              <el-button
                type="primary"
                size="mini"
                class="bianji"
                style="margin-left: 10px"
              >
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button
                    @click="chengyuanliebiao(scope.row)"
                    style="margin-bottom: 8px"
                    size="mini"
                  >
                    成员列表
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button size="mini" @click="resetPass(scope.row)">
                    重置密码
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button size="mini" @click="delss(scope.row)">
                    删除
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 15, 20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <vxe-modal
      width="336"
      ref="shifoushangjia"
      height="182"
      size="small"
      :show-footer="false"
      :showHeader="false"
      :show-close="true"
    >
      <div class="popchuangkou">
        <img
          src="../../assets/img/closeaaaa.png"
          alt=""
          class="dsff"
          @click="plClose"
        />
        <div class="titledd">
          是否确认{{ itemcc.is_status === 1 ? "下架" : "上架" }}该协会?
        </div>
        <div class="bobox">
          <button class="queren" @click="plqueren">确认</button>
          <button class="quxiao" @click="plClose">取消</button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal
      ref="dakaizhiding"
      title="开通记录"
      width="1200"
      height="400"
      :mask="false"
      :lock-view="false"
      resize
    >
      <template #default>
        <div class="headetrxsadf">
          <div class="leftdsss">
            <div class="titleddss">
              {{ zhidingQuery.org_com }}
            </div>
          </div>
          <div class="right">
            <div class="huiyuanzhuangtai">
              会员状态
              <span
                class="sdadwee"
                :style="{
                  color:
                    zhidingQuery.istop_surplusdays === 0
                      ? '#000000'
                      : '#0FA838',
                }"
              >
                {{ zhidingQuery.istop_surplusdays === 0 ? "普通用户" : "会员" }}
              </span>
              <span
                class="sadgggvv"
                v-if="zhidingQuery.istop_surplusdays !== 0"
              >
                (剩余{{ zhidingQuery.istop_surplusdays }}天)
              </span>
            </div>
          </div>
        </div>
        <vxe-table
          border
          show-overflow
          keep-source
          ref="xTable"
          max-height="400"
          :data="zhidingQuery.top_pay"
          align="center"
          :edit-config="{
            trigger: 'click',
            mode: 'cell',
            icon: 'fa fa-pencil',
            showStatus: true,
          }"
        >
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <!-- <vxe-table-column field="modular_name" title="置顶类型"></vxe-table-column> -->
          <vxe-table-column field="paytime" title="开通时间"></vxe-table-column>
          <vxe-table-column field="days" title="开通时长/天"></vxe-table-column>
          <vxe-table-column
            field="paymoney"
            title="收费金额/元"
          ></vxe-table-column>
          <vxe-table-column
            field="pay_type"
            title="支付方式 "
          ></vxe-table-column>
          <vxe-table-column
            field="order_no"
            title="订单号"
            width="260"
          ></vxe-table-column>
        </vxe-table>
      </template>
    </vxe-modal>

    <Chengyuanliebiao ref="Chengyuanliebiao" />
  </div>
</template>

<script>
import Chengyuanliebiao from "./components/Chengyuanliebiao";

import {
  istoprecord,
  setstatus,
  sxhList,
  busidel,
  resetPassWithAssocition,
} from "@/api/shangxiehui";
import { getWzArea } from "@/api/city";

export default {
  name: "index",
  components: { Chengyuanliebiao },
  data() {
    return {
      CityName: null,
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad,
        },
      },
      areaList: [],
      optiontype: [
        {
          value: "1",
          label: "商会 ",
        },
        {
          value: "2",
          label: "协会",
        },
      ],
      cur_page: 1,
      pageshow: true,
      tableData: [],
      query: {
        is_status: 0,
        apply_date: "",
        org_provinceid: 0,
        org_cityid: 0,
        org_areaid: "",
        org_type: "",
        keyword: "",
        page: 1,
        pagesize: 10,
      },
      total: null,
      itemcc: {},
      zhidingQuery: {},
    };
  },
  created() {
    this.xiehuiList();
    this.getAreaList();
  },
  methods: {
    routeAdd() {
      this.$router.push("/AddXiehui");
    },
    Editscs(item) {
      this.$router.push("/AddXiehui?id=" + item.id);
    },
    resetPass(item) {
      this.$confirm(`确认重置【${item.org_com}】密码吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          resetPassWithAssocition({
            id: item.id,
          }).then((resp) => {
            this.$notify({
              title: "温馨提示",
              message: resp.data.msg,
              type: "warning",
            });
          });
        })
        .catch(() => {});
    },
    delss(item) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem("token"),
            id: item.id,
          };
          busidel(obj).then(({ data: res }) => {
            console.log(item);
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              setTimeout(() => {
                window.sessionStorage.clear();
                this.$router.push("/login");
              }, 1000);
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: "error",
                duration: "2000",
              });
              return false;
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: "success",
                duration: "2000",
              });
              this.handleCurrentChange(this.query.page);
            }
          });
        })
        .catch(() => {});
    },
    async lazyLoad(node, resolve) {
      const level = node.level;
      let result;
      let res;
      let param;
      switch (level) {
        case 0: // 一级
          res = await province();
          result = res.data.list;
          result.forEach((item) => {
            item.value = item.province_id;
            item.label = item.province_name;
          });
          break;
        case 1: // 二级
          console.log(node.data.province_id);
          param = {
            province_id: node.data.province_id,
          };
          res = await city(param);
          result = res.data.list;
          // console.log(result)
          result.forEach((item) => {
            item.value = item.city_id;
            item.label = item.city_name;
          });
          break;
        case 2: // 三级目录
          console.log(node.data.city_id);
          param = {
            city_id: node.data.city_id,
          };
          res = await area(param);
          result = res.data.list;
          result.forEach((item) => {
            item.value = item.area_id;
            item.label = item.area_name;
            item.leaf = level >= 2;
          });
          break;
        // case 3: // 三级目录
        //   param = {
        //     area_id: node.data.area_id
        //   }
        // res = await getStreet(
        //   param
        // )
        // result = res.list
        // result.forEach((item) => {
        //   item.value = item.street_id
        //   item.label = item.short_name
        //   // 大于三级后不再显示后面的，到此结束
        //   item.leaf = level >= 3
        // })
        // break
        default:
          result = [];
          break;
      }
      console.log(result);
      resolve(result);
    },
    zhidingjilu(row) {
      this.$refs.dakaizhiding.open();
      const obj = {
        token: sessionStorage.getItem("token"),
        id: row.id,
      };
      istoprecord(obj).then(({ data: res }) => {
        console.log("resssadca", res);
        this.zhidingQuery = res;
      });
    },
    plClose() {
      this.$refs.shifoushangjia.close();
      this.xiehuiList();
    },
    plqueren() {
      if (this.itemcc.is_status === 1) {
        this.itemcc.is_status = 0;
      } else {
        this.itemcc.is_status = 1;
      }
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.itemcc.id,
        is_status: this.itemcc.is_status,
      };
      setstatus(obj).then(({ data: res }) => {
        console.log("res", res);
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          setTimeout(() => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          }, 1000);
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          return false;
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: "2000",
          });
          this.$refs.shifoushangjia.close();
          this.xiehuiList();
        }
      });
    },
    sexChangeListOption(item) {
      console.log("row", item);
      this.itemcc = item;
      this.$refs.shifoushangjia.open();
    },
    Discountsearch() {
      this.cur_page = 1;
      this.xiehuiList();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    handleSizeChange(val) {
      this.query.pagesize = val;
      this.handleCurrentChange(this.query.page);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      const obj = {
        token: sessionStorage.getItem("token"),
        pagesize: this.query.pagesize,
        page: this.query.page,
        apply_date: this.query.apply_date,
        org_provinceid: this.query.org_provinceid,
        org_cityid: this.query.org_cityid,
        org_areaid: this.query.org_areaid,
        org_type: this.query.org_type,
        keyword: this.query.keyword,
      };
      sxhList(obj).then(({ data: res }) => {
        console.log("res", res);
        this.tableData = res.list;
        this.total = res.total;
        this.tableData.forEach((i) => {
          if (i.is_status === 0) {
            i.shangjia = false;
          } else if (i.is_status === 1) {
            i.shangjia = true;
          }
        });
      });
    },
    xiehuiList() {
      const obj = {
        token: sessionStorage.getItem("token"),
        pagesize: this.query.pagesize,
        page: this.query.page,
        apply_date: this.query.apply_date,
        org_provinceid: this.query.org_provinceid,
        org_cityid: this.query.org_cityid,
        org_areaid: this.query.org_areaid,
        org_type: this.query.org_type,
        keyword: this.query.keyword,
        is_status: this.query.is_status,
      };
      sxhList(obj).then(({ data: res }) => {
        console.log("res", res);
        this.tableData = res.list;
        this.total = res.total;
        this.tableData.forEach((i) => {
          if (i.is_status === 0) {
            i.shangjia = false;
          } else if (i.is_status === 1) {
            i.shangjia = true;
          }
        });
      });
    },
    xiehuixiangqing(row) {
      // this.$store.commit("setshangxiehuixiangqing", row.id);
      this.$router.push("/shangxiehuixiangqing?id=" + row.id);
    },
    chengyuanliebiao(row) {
      this.$refs.Chengyuanliebiao.handleOpenDialog(row);
    },
    async getAreaList() {
      try {
        const res = await getWzArea();
        const result = res.data.data;
        result.forEach((item) => {
          item.value = item.code;
          item.label = item.name;
        });
        this.areaList = result;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-scrollbar__wrap {
  height: 200px;
}
.rou {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .mr {
    margin-right: 12px;
  }
}
.headetrxsadf {
  display: flex;
  flex-direction: row;
  height: 74px;
  align-items: center;
  .leftdsss {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    .titleddss {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      //text-align: left;
      color: #2e2e2e;
      .idss {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        //text-align: left;
        color: #2e2e2e;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: row;
    align-items: center;
    .huiyuanzhuangtai {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      text-align: left;
      color: #a1a1a1;
      margin-right: 8px;
      .sdadwee {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
      }
      .sadgggvv {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #0fa838;
      }
    }
  }
}
.popchuangkou {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP {
    margin-bottom: 24px;
  }
  .dsff {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd {
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput {
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox {
    margin-top: 43px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .queren {
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg, #3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao {
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61, 154, 255, 0.1);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.weizhiding {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.yizhiding {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.dsaggg {
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61, 154, 255, 0.5);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
}
.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;
    .left {
      margin-right: 150px;
      .btn {
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg, #1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border: none;
      }
    }
    .right {
      margin-top: 27px;
    }
  }
}
</style>
